import { FlatList } from 'react-native';
import {
    type ColorTokenKey,
    Icon,
    type IconType,
    SPACE_COLORS,
    SPACE_ICONS,
    SPACE_SECONDARY_COLORS,
    View,
    YStack,
} from 'smoothie';

interface ColorSelectionProps {
    icon: string;
    selectedColor: string;
    onSelect: (color: string) => void;
}

const ColorSelection = ({
    icon,
    selectedColor,
    onSelect,
}: ColorSelectionProps) => {
    const colors = Object.keys(SPACE_COLORS).filter(
        (color) => color !== 'greenleaf',
    ); // TODO: Clean up later after handling legacy color scheme

    return (
        <YStack alignItems="center">
            <FlatList
                numColumns={3}
                data={colors}
                renderItem={({ item: color }) => (
                    <ColorSelect
                        icon={icon}
                        color={color}
                        isSelected={selectedColor === color}
                        onPress={() => {
                            onSelect(color);
                        }}
                    />
                )}
            />
        </YStack>
    );
};

interface ColorProps {
    color: string;
    icon: string;
    isSelected: boolean;
    onPress: () => void;
}

const ColorSelect = ({ color, icon, isSelected, onPress }: ColorProps) => {
    const colorValue = SPACE_COLORS[color];
    return (
        <View
            margin={4}
            padding={40}
            borderRadius={12}
            backgroundColor={colorValue}
            borderWidth={1}
            borderColor={isSelected ? '$green900' : colorValue}
            onPress={onPress}
        >
            <IconComponent
                icon={icon}
                primaryColor={SPACE_SECONDARY_COLORS[color] as string}
            />
        </View>
    );
};

interface IconProps {
    icon: string;
    primaryColor: string;
}

const IconComponent = ({ icon, primaryColor }: IconProps) => {
    return (
        <Icon
            icon={SPACE_ICONS[icon] as IconType}
            size={24}
            color={primaryColor as ColorTokenKey}
        />
    );
};

export default ColorSelection;
